import { render, staticRenderFns } from "./ItemsServices.vue?vue&type=template&id=4422bd6a&scoped=true&"
import script from "./ItemsServices.vue?vue&type=script&lang=js&"
export * from "./ItemsServices.vue?vue&type=script&lang=js&"
import style0 from "./ItemsServices.vue?vue&type=style&index=0&id=4422bd6a&lang=scss&scoped=true&"
import style1 from "./ItemsServices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4422bd6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4422bd6a')) {
      api.createRecord('4422bd6a', component.options)
    } else {
      api.reload('4422bd6a', component.options)
    }
    module.hot.accept("./ItemsServices.vue?vue&type=template&id=4422bd6a&scoped=true&", function () {
      api.rerender('4422bd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/edit/ItemsServices.vue"
export default component.exports